import type { ValidationConfig } from '../../../core/dataProcessor/types';

export const scatterValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'size', type: 'number', required: false },
    { field: 'color', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'scatter-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: 'Scatter plot requires more than 1 data point to be effective',
      suggestion: 'Provide at least 2 data points for meaningful scatter visualization',
      severity: 'warning'
    }
  ]
};
